(() => {
  const LOGO_FEE_ID = 52199112573218;
  const STATIC_COMPONENTS = {
    'paper-a5': {
      variants: [
        { id: 52304675373346, options: ['A5', 'Dourado'], price: 14800, available: true },
        { id: 52304675406114, options: ['A5', 'Prata'], price: 14800, available: true },
        { id: 52304675438882, options: ['A5', 'Rosé'], price: 14800, available: true },
      ],
      images: ['//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-papel-dourado.jpg?v=1786413687&width=1600', '//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-papel-prata.jpg?v=1786413687&width=1600', '//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-papel-rose.jpg?v=1786413687&width=1600'],
    },
    'paper-a4': {
      variants: [
        { id: 52304675471650, options: ['A4', 'Dourado'], price: 19800, available: true },
        { id: 52304675504418, options: ['A4', 'Prata'], price: 19800, available: true },
        { id: 52304675537186, options: ['A4', 'Rosé'], price: 19800, available: true },
      ],
      images: ['//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-papel-dourado.jpg?v=1786413687&width=1600', '//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-papel-prata.jpg?v=1786413687&width=1600', '//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-papel-rose.jpg?v=1786413687&width=1600'],
    },
    pencil: {
      variants: [{ id: 52304657252642, options: ['Dourado'], price: 9600, available: true }, { id: 52304657285410, options: ['Prata'], price: 9600, available: true }, { id: 52304657318178, options: ['Rosé'], price: 9600, available: true }],
      images: ['//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-lapis-dourado.jpg?v=1786413521&width=1600', '//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-lapis-prata.jpg?v=1786413521&width=1600', '//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-lapis-rose.jpg?v=1786413521&width=1600'],
    },
    card: {
      variants: [{ id: 52304656826658, options: ['Dourado'], price: 7200, available: true }, { id: 52304656859426, options: ['Prata'], price: 7200, available: true }, { id: 52304656892194, options: ['Rosé'], price: 7200, available: true }],
      images: ['//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-cartao-dourado.jpg?v=1786413494&width=1600', '//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-cartao-prata.jpg?v=1786413494&width=1600', '//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-cartao-rose.jpg?v=1786413494&width=1600'],
    },
    clips: {
      variants: [{ id: 52304686645538, options: ['Dourado'], price: 6200, available: true }, { id: 52304661446946, options: ['Prata'], price: 6200, available: true }, { id: 52304652599586, options: ['Rosé'], price: 6200, available: true }],
      images: ['//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-clips-dourado.jpg?v=1786412989&width=1600', '//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-clips-prata.jpg?v=1786412989&width=1600', '//cdn.shopify.com/s/files/1/1009/4457/6802/files/kit-escritorio-espelhado-porta-clips-rose.jpg?v=1786412989&width=1600'],
    },
  };
  const money = (cents) => (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const finishIndex = (finish) => ({ Dourado: 0, Prata: 1, 'Rosé': 2 }[finish] ?? 0);
  const selectOnly = (root, selector, button) => root.querySelectorAll(selector).forEach((item) => {
    const selected = item === button;
    item.classList.toggle('is-on', selected);
    item.setAttribute('aria-checked', String(selected));
  });

  function init(root) {
    if (root.dataset.wogReady === 'true') return;
    root.dataset.wogReady = 'true';
    const product = JSON.parse(root.querySelector('[data-wog-product]').textContent);
    (product.components || []).forEach((component) => {
      if (!Array.isArray(component.variants) || !component.variants.length) component.variants = STATIC_COMPONENTS[component.key]?.variants || [];
      if (!Array.isArray(component.images) || !component.images.length) component.images = STATIC_COMPONENTS[component.key]?.images || [];
    });
    const state = {
      size: root.querySelector('[data-wog-size]')?.dataset.wogSize || '',
      finish: root.querySelector('[data-wog-finish]')?.dataset.wogFinish || '',
      mode: 'Nome ou iniciais',
      purchase: 'complete',
      view: 'product',
      quantities: Object.fromEntries((product.components || []).map((component) => [component.key, 0])),
    };
    const main = root.querySelector('[data-wog-main]');
    const personalization = root.querySelector('[data-wog-personalization-preview]');
    const error = root.querySelector('[data-wog-error]');
    const file = root.querySelector('[data-wog-file]');

    const currentVariant = () => product.variants.find((variant) => product.hasSize
      ? variant.options[0] === state.size && variant.options[1] === state.finish
      : variant.options[0] === state.finish);
    const componentVariant = (component) => component.variants.find((variant) => component.size
      ? variant.options[0] === component.size && variant.options[1] === state.finish
      : variant.options[0] === state.finish);
    const regularBundleTotal = () => (product.components || []).filter((component) => component.key !== (state.size === 'A5' ? 'paper-a4' : 'paper-a5')).reduce((sum, component) => sum + (componentVariant(component)?.price || 0), 0);
    const customLines = () => (product.components || []).map((component) => ({ component, variant: componentVariant(component), quantity: state.quantities[component.key] || 0 })).filter((line) => line.quantity > 0);
    const baseTotal = () => {
      if (!product.isKit || state.purchase === 'complete') return currentVariant()?.price || 0;
      return customLines().reduce((sum, line) => sum + ((line.variant?.price || 0) * line.quantity), 0);
    };

    function showView(view) {
      state.view = view;
      if (main) main.hidden = view !== 'product';
      personalization.hidden = view !== 'personalization';
      root.querySelectorAll('[data-wog-view]').forEach((button) => button.classList.toggle('is-on', button.dataset.wogView === view));
      root.querySelectorAll('[data-wog-thumb]').forEach((button) => button.classList.remove('is-on'));
    }

    function updatePreviewText(openPreview = false) {
      const line1 = root.querySelector('[data-wog-line1]').value.trim();
      const line2 = root.querySelector('[data-wog-line2]').value.trim();
      root.querySelector('[data-wog-preview-line1]').textContent = state.mode === 'Logo' ? 'SUA LOGO' : (line1 || 'Seu nome');
      root.querySelector('[data-wog-preview-line2]').textContent = state.mode === 'Logo' ? 'ARTE PARA APROVAÇÃO' : (line2 || 'Sua segunda linha');
      root.querySelector('[data-wog-preview-line2]').hidden = state.mode !== 'Logo' && !line2;
      if (openPreview && (line1 || line2 || state.mode === 'Logo')) showView('personalization');
    }

    function updateFinishMedia(button) {
      if (button.dataset.image && main) {
        main.src = button.dataset.image;
        root.querySelector('[data-wog-product-thumb]').src = button.dataset.image;
        root.querySelector('[data-wog-summary-image]')?.setAttribute('src', button.dataset.image);
      }
      if (button.dataset.plate) {
        root.querySelector('[data-wog-plate]').src = button.dataset.plate;
        root.querySelector('[data-wog-plate-thumb]').src = button.dataset.plate;
      }
      (product.components || []).forEach((component) => {
        const image = component.images?.[finishIndex(state.finish)];
        const node = root.querySelector(`[data-wog-component="${component.key}"] [data-wog-component-image]`);
        if (node && image) node.src = image;
      });
    }

    function update() {
      const variant = currentVariant();
      const lines = customLines();
      const total = baseTotal() + (state.mode === 'Logo' ? 3500 : 0);
      root.querySelectorAll('[data-wog-price]').forEach((node) => { node.textContent = money(total); });
      root.querySelector('[data-wog-regular-price]')?.replaceChildren(document.createTextNode(money(regularBundleTotal())));
      const choices = [state.finish, state.mode];
      if (product.isKit) {
        if (state.purchase === 'complete') choices.unshift(`Kit completo ${state.size} · 15% OFF`);
        else choices.unshift(lines.length ? lines.map((line) => `${line.quantity}× ${line.component.name}`).join(' + ') : 'Monte seu kit · nenhum item selecionado');
      } else if (state.size) choices.unshift(state.size);
      root.querySelector('[data-wog-summary]').textContent = choices.filter(Boolean).join(' · ');
      root.querySelectorAll('[data-wog-component]').forEach((row) => {
        const component = product.components.find((item) => item.key === row.dataset.wogComponent);
        const resolved = componentVariant(component);
        row.querySelector('[data-wog-component-price]').textContent = resolved ? money(resolved.price) : 'Indisponível';
        row.classList.toggle('is-on', (state.quantities[component.key] || 0) > 0);
      });
      const valid = product.isKit && state.purchase === 'custom' ? lines.length > 0 && lines.every((line) => line.variant?.available) : Boolean(variant?.available);
      root.querySelector('[data-wog-add]').disabled = !valid;
    }

    root.querySelectorAll('[data-wog-size]').forEach((button) => button.addEventListener('click', () => { state.size = button.dataset.wogSize; selectOnly(root, '[data-wog-size]', button); update(); }));
    root.querySelectorAll('[data-wog-finish]').forEach((button) => button.addEventListener('click', () => { state.finish = button.dataset.wogFinish; selectOnly(root, '[data-wog-finish]', button); updateFinishMedia(button); update(); }));
    root.querySelectorAll('[data-wog-mode]').forEach((button) => button.addEventListener('click', () => {
      state.mode = button.dataset.wogMode; selectOnly(root, '[data-wog-mode]', button);
      root.querySelector('[data-wog-text]').hidden = state.mode === 'Logo'; root.querySelector('[data-wog-logo]').hidden = state.mode !== 'Logo';
      updatePreviewText(true); update();
    }));
    root.querySelectorAll('[data-wog-purchase]').forEach((button) => button.addEventListener('click', () => {
      state.purchase = button.dataset.wogPurchase; selectOnly(root, '[data-wog-purchase]', button);
      root.querySelector('[data-wog-complete]').hidden = state.purchase !== 'complete'; root.querySelector('[data-wog-builder]').hidden = state.purchase !== 'custom'; update();
    }));
    root.querySelectorAll('[data-wog-component]').forEach((row) => row.querySelectorAll('[data-wog-qty]').forEach((button) => button.addEventListener('click', () => {
      const key = row.dataset.wogComponent; const delta = button.dataset.wogQty === '+' ? 1 : -1;
      state.quantities[key] = Math.max(0, (state.quantities[key] || 0) + delta); row.querySelector('[data-wog-count]').textContent = state.quantities[key]; update();
    })));
    root.querySelectorAll('[data-wog-view]').forEach((button) => button.addEventListener('click', () => showView(button.dataset.wogView)));
    root.querySelectorAll('[data-wog-thumb]').forEach((button) => button.addEventListener('click', () => { showView('product'); button.classList.add('is-on'); if (main) { main.src = button.dataset.image; main.alt = button.dataset.alt || product.title; } }));
    root.querySelectorAll('[data-wog-line1],[data-wog-line2]').forEach((input) => input.addEventListener('input', () => updatePreviewText(true)));
    file?.addEventListener('change', () => { root.querySelector('[data-wog-filename]').textContent = file.files[0]?.name || 'Nenhum arquivo selecionado'; });

    root.querySelector('[data-wog-add]').addEventListener('click', async function () {
      error.hidden = true;
      const line1 = root.querySelector('[data-wog-line1]').value.trim();
      if (state.mode === 'Logo' && !file.files.length) { error.textContent = 'Selecione o arquivo da logo.'; error.hidden = false; file.focus(); return; }
      if (state.mode !== 'Logo' && !line1) { error.textContent = 'Preencha o nome ou a primeira linha.'; error.hidden = false; root.querySelector('[data-wog-line1]').focus(); return; }
      if (!root.querySelector('[data-wog-confirm]').checked) { error.textContent = 'Confirme a revisão da configuração.'; error.hidden = false; return; }
      const lines = product.isKit && state.purchase === 'custom'
        ? customLines().map((line) => ({ id: line.variant.id, quantity: line.quantity, name: line.component.name }))
        : [{ id: currentVariant()?.id, quantity: 1, name: product.title }];
      if (!lines.length || lines.some((line) => !line.id)) { error.textContent = 'Selecione pelo menos um item disponível.'; error.hidden = false; return; }

      const form = new FormData();
      const notes = root.querySelector('[data-wog-notes]').value.trim();
      const line2 = root.querySelector('[data-wog-line2]').value.trim();
      lines.forEach((line, index) => {
        form.append(`items[${index}][id]`, String(line.id)); form.append(`items[${index}][quantity]`, String(line.quantity));
        form.append(`items[${index}][properties][Acabamento espelhado]`, state.finish);
        form.append(`items[${index}][properties][Tipo de personalização]`, state.mode);
        form.append(`items[${index}][properties][Composição]`, product.isKit && state.purchase === 'custom' ? 'Montado item a item' : (product.isKit ? 'Kit completo com 15% OFF' : 'Produto individual'));
        if (product.isKit && state.purchase === 'custom') form.append(`items[${index}][properties][Componente]`, line.name);
        if (state.mode === 'Logo') { if (index === 0) form.append(`items[${index}][properties][Arquivo da logo]`, file.files[0]); }
        else { form.append(`items[${index}][properties][Nome ou primeira linha]`, line1); if (line2) form.append(`items[${index}][properties][Segunda linha]`, line2); }
        if (notes) form.append(`items[${index}][properties][Observações]`, notes);
      });
      if (state.mode === 'Logo') {
        const index = lines.length; form.append(`items[${index}][id]`, String(LOGO_FEE_ID)); form.append(`items[${index}][quantity]`, '1');
        form.append(`items[${index}][properties][Serviço]`, 'Tratamento profissional da logo'); form.append(`items[${index}][properties][Aplicado a]`, product.title);
      }
      this.disabled = true; this.textContent = 'Adicionando…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', body: form, headers: { Accept: 'application/json' } });
        if (!response.ok) { const payload = await response.json(); throw new Error(payload.description || 'Não foi possível adicionar o produto.'); }
        await window.WeArtCart.openAfterAdd();
      } catch (cause) { error.textContent = cause.message || 'Não foi possível adicionar o produto.'; error.hidden = false; }
      finally { this.disabled = false; this.textContent = 'Adicionar ao carrinho'; }
    });

    updateFinishMedia(root.querySelector('[data-wog-finish].is-on'));
    updatePreviewText();
    update();
  }

  const boot = () => document.querySelectorAll('[data-wog]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
